module.exports = __webpack_public_path__ + "img/about-web-design-iconimg2.8b31d4a1.png";